import { Card, Checkbox, FormLayout, TextField } from "@shopify/polaris";

const CouponSettings = ({
  usageLimit,
  setUsageLimit,
  editable,
  appliesOncePerCustomer,
  setAppliesOncePerCustomer,
  setStartsAt,
  startsAt,
  endsAt,
  setEndsAt,
  minimumPurchaseAmount,
  setMinimumPurchaseAmount,
}) => {
  return (
    <Card title="Coupon Usage Details" sectioned>
      <FormLayout>
        <TextField
          label="Usage Limit"
          value={usageLimit}
          placeholder="e.g. 100"
          onChange={(value) => setUsageLimit(value)}
          type="number"
          disabled={!editable}
        />
        <Checkbox
          label="Applies Once Per Customer"
          checked={appliesOncePerCustomer}
          onChange={(value) => setAppliesOncePerCustomer(value)}
          disabled={!editable}
        />
        <TextField
          label="Starts At"
          value={startsAt ? new Date(startsAt).toISOString().slice(0, 16) : ""}
          onChange={(value) => setStartsAt(value)}
          type="datetime-local"
          disabled={!editable}
        />
        <TextField
          label="Ends At"
          value={endsAt ? new Date(endsAt).toISOString().slice(0, 16) : ""}
          onChange={(value) => setEndsAt(value)}
          type="datetime-local"
          disabled={!editable}
        />
        <TextField
          label="Minimum Purchase Amount"
          placeholder="e.g. 200"
          value={minimumPurchaseAmount}
          onChange={(value) => setMinimumPurchaseAmount(value)}
          type="number"
          prefix="₹"
          disabled={!editable}
        />
      </FormLayout>
    </Card>
  );
};

export default CouponSettings;
